import React, { Component } from 'react';
import Event from "./../../../../../assets/PubJs/hcPub"//所有事件

import {connect} from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件

import "./style.css"//引入样式表
import { Button } from 'antd';
import Crumbs from './../../../Crumbs/Crumbs';//面包屑
import img from './../../../../../assets/images/noCompany.png';//无内容图片
import CompanyModal from "./../CompanyModal/index"//组件携带参数“0”或者“1”，0为有切换用户，1无切换用户

class App extends Component {
    state = {
        hei: 500,
        CrumbsTitle:""
    };

    //窗体大小
    windowChangeSize() {
        let H = window.innerHeight - 229;
        this.setState({
            hei: H<400?400:H
        })
    }

    //弹出切换绑定企业弹框
    showModal(){
        this.props.dispatch(evn.showModal())
    }

    //组件完成后
    componentDidMount() {
        let locationUrl = window.location.href;
        if (locationUrl.lastIndexOf('CompanyList') >= 0) {
            this.setState({
                CrumbsTitle: "主体管理 / 主体设置"
            })
            Event.NavShow(this, "/Content/Business/CompanyList", "Business")//显示菜单
        } else if (locationUrl.lastIndexOf('CompanyRegistration') >= 0) {
            this.setState({
                CrumbsTitle: "自行和解 / 和解登记"
            })
            Event.NavShow(this, "/Content/Business/CompanyRegistration", "CompanyRegistration")//显示菜单
        }
        this.windowChangeSize();
    }
    render() {
        return (
            <div id="FristLogin" >
                {/* <Crumbs title={this.state.CrumbsTitle} /> */}
                <div id="FristLoginContent" style={{ minHeight: this.state.hei }}>
                    <div className="LoginNoNews">
                        <CompanyModal type={"1"}/>
                        <img src={img} alt={"加载中..."} />
                        <h2>您还没有绑定/加入任何企业</h2>
                        <h3>本模块需要绑定/加入企业后才能显示，请您先进行绑定/加入一个企业</h3>
                        <Button onClick={this.showModal.bind(this)} type="primary">绑定/加入企业</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyFristLogin/CompanyFristLogin.js